<template>
  <div
    class="mobile-header"
    v-show="isMobileSite || alwaysShow"
    :style="{ paddingTop: statusBarHeight + 'px' }"
    v-cloak
  >
    <div
      class="fixed"
      ref="fixed"
      :style="[
        {
          color: customColor || '',
          background: customBackgroundColor || '',
          borderBottom: borderBottom || '1px solid #eee'
        },
        { paddingTop: statusBarHeight + 'px' }
      ]"
    >
      <template>
        <a
          v-if="seoBack && seoBack.href"
          :href="seoBack.href"
          :title="seoBack.title"
        >
          <div class="header-left">
            <i class="icon icon-node-website icon-m-left"></i>
          </div>
        </a>
        <div v-else-if="!hideLeft" class="header-left" @click="goBack">
          <i class="icon icon-node-website icon-m-left"></i>
          <span class="backTxt" v-if="backTxt">{{ backTxt }}</span>
        </div>
      </template>

      <div class="head-middle">
        <!-- 插槽样式 -->
        <template v-if="$slots.navTitle">
          <slot name="navTitle"></slot>
        </template>
        <!-- 正常样式 -->
        <template v-else>
          <template v-if="navTitleUseDiv">
            <div v-if="navTitle" class="nav-title">{{ navTitle }}</div>
          </template>
          <template v-else>
            <h1 v-if="navTitle" class="nav-title">{{ navTitle }}</h1>
          </template>
        </template>
      </div>

      <div class="header-right" v-if="rightTxt" @click="rightFun">
        <slot v-if="$slots.optBtnRight" name="optBtnRight"></slot>
        <span v-else class="right-txt" :style="rightTxtStyle">{{
          rightTxt
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobileSite: false,
      statusBarHeight: 0
    }
  },

  props: [
    'navTitle',
    'navTitleUseDiv',
    'prevPath',
    'goBack',
    'optBtn',
    'optTxt',
    'headerOpt',
    'customColor',
    'customBackgroundColor',
    'borderBottom',
    'alwaysShow',
    'hideLeft',
    'backTxt',
    'rightTxt',
    'rightFun',
    'rightTxtStyle',
    'seoBack'
  ],
  computed: {
    isApp() {
      if (this.$isServer) return false
      return this.$platform.isYixinliApp || this.$platform.isZiXunApp
    }
  },
  created() {
    if (this.isApp) {
      this.statusBarHeight = 20
      this.isMobileSite = false
    } else {
      this.isMobileSite = true
    }
  },
  mounted() {
    this.$emit('statusBar', this.statusBarHeight)
    if (this.isApp) {
      this.$bridge.hasNotch().then(({ statusBarHeight }) => {
        this.statusBarHeight = statusBarHeight
        this.$emit('statusBar', this.statusBarHeight)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.mobile-header {
  width: 100%;
  height: 88px;
  .fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: 750px;
    height: 88px;
    background-color: #118bd0;
    color: #fff;
    z-index: 12;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 0.2s;
    .header-left {
      white-space: nowrap;
      padding: 0 26px;
      display: flex;
      align-items: center;
      .icon-m-left {
        display: inline-block;
        color: #2b2b2b;
        font-size: 34px;
      }
      .backTxt {
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #4a5161;
        line-height: 26px;
      }
    }
    .head-middle {
      overflow: hidden;
      position: absolute;
      width: 100%;
      z-index: -99;
      .nav-title {
        font-family: PingFangSC-Medium;
        font-size: 38px;
        color: #4a5161;
        height: 88px;
        text-align: center;
        line-height: 88px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .header-right {
      display: inline-block;
      white-space: nowrap;
      margin-right: 30px;
      .right-txt {
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #4a5161;
        text-align: right;
      }
    }
  }
}
</style>
